// src/components/common/PageTitle.jsx (atau src/components/PageTitle.jsx)
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const PageTitle = () => {
  const location = useLocation();

  useEffect(() => {
    // Map routes to titles
    const titleMap = {
      // Public pages
      '/': 'Home',
      '/villas': 'Our Villas',
      '/business': 'Business Packages',
      '/services': 'Services',
      '/profile': 'About Us',
      '/contact': 'Contact Us',
      
      // Admin pages
      '/admin/login': 'Admin Login',
      '/admin/dashboard': 'Dashboard',
      '/admin/villas': 'Manage Villas',
      '/admin/business': 'Manage Business Packages',
      '/admin/services': 'Manage Services',
      '/admin/contacts': 'Contact Messages',
      '/admin/settings': 'Settings',
    };

    // Get title from map or use pathname
    const pathname = location.pathname;
    let pageTitle = titleMap[pathname];

    // Handle dynamic routes (routes with IDs)
    if (!pageTitle) {
      // Villa detail routes
      if (pathname.startsWith('/villas/') && pathname !== '/villas') {
        pageTitle = 'Villa Details';
      }
      // Admin villa edit routes (if you have them)
      else if (pathname.includes('/admin/villas/edit/')) {
        pageTitle = 'Edit Villa';
      }
      else if (pathname.includes('/admin/villas/create')) {
        pageTitle = 'Create Villa';
      }
      // Admin business edit routes (if you have them)
      else if (pathname.includes('/admin/business/edit/')) {
        pageTitle = 'Edit Business Package';
      }
      else if (pathname.includes('/admin/business/create')) {
        pageTitle = 'Create Business Package';
      }
      // Admin service edit routes (if you have them)
      else if (pathname.includes('/admin/services/edit/')) {
        pageTitle = 'Edit Service';
      }
      else if (pathname.includes('/admin/services/create')) {
        pageTitle = 'Create Service';
      }
      // Default fallback
      else {
        pageTitle = 'Page';
      }
    }

    // Set the document title
    document.title = `Dewanta Villas Management - ${pageTitle}`;
  }, [location]);

  return null; // This component doesn't render anything
};

export default PageTitle;